import * as types from './actionTypes'

export const createSmsTemplate = (data) => ({
    type: types.SMS_TEMPLATE_CREATE,
    data
})

export const createSmsTemplateSuccess = () => ({
    type: types.SMS_TEMPLATE_CREATE_SUCCESS
})

export const createSmsTemplateFailed = () => ({
    type: types.SMS_TEMPLATE_CREATE_FAILED
})

export const deleteSmsTemplate = (form) => ({
    type: types.SMS_TEMPLATE_DELETE,
    form
})

export const deleteSmsTemplateSuccess = (id) => ({
    type: types.SMS_TEMPLATE_DELETE_SUCCESS,
    id
})

export const deleteSmsTemplateFailed = () => ({
    type: types.SMS_TEMPLATE_DELETE_FAILED
})

export const updateSmsTemplate = (data) => ({
    type: types.SMS_TEMPLATE_UPDATE,
    data
})

export const updateSmsTemplateSuccess = () => ({
    type: types.SMS_TEMPLATE_UPDATE_SUCCESS
})

export const updateSmsTemplateFailed = () => ({
    type: types.SMS_TEMPLATE_UPDATE_SUCCESS
})

export const resetSmsTemplate = () => ({
    type: types.SMS_TEMPLATE_RESET
})

export const sendSmsTemplate = (template, documents, save, test) => ({
    type: types.SMS_TEMPLATE_SEND,
    template,
    documents,
    save,
    test
})

export const sendSmsTemplateSuccess = (result, test) => ({
    type: types.SMS_TEMPLATE_SEND_SUCCESS,
    result,
    test
})

export const sendSmsTemplateFailed = () => ({
    type: types.SMS_TEMPLATE_SEND_FAILED
})

export const getSmsTemplate = (id) => ({
    type: types.SMS_TEMPLATE_FETCH,
    id
})

export const getSmsTemplateSuccess = (template) => ({
    type: types.SMS_TEMPLATE_FETCH_SUCCESS,
    template
})

export const getSmsTemplateFailed = () => ({
    type: types.SMS_TEMPLATE_FETCH_FAILED
})

export const setSmsTemplatesOrder = (entity, order) => ({
    type: types.SET_SMS_TEMPLATES_ORDER,
    entity,
    order
})
